import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import { Role } from '~/apollo/generated/v3/graphql';
import { useAuth } from '~/contexts/auth';
import { cn } from '~/utils/common';

export function PublishedContainer({
  published,
  children,
  strokeWidth = 'md',
  withIcon = false,
}: {
  published: boolean;
  children: ReactNode;
  strokeWidth?: 'sm' | 'md';
  withIcon?: boolean;
}) {
  const { hasAnyRole } = useAuth();

  // Only admins see published indicators
  if (!hasAnyRole([Role.RoleAdmin])) {
    return children;
  }

  const showIcon = !published && withIcon;

  return (
    <div
      className={cn({
        'border-2 p-1': !published && strokeWidth === 'sm',
        'border-4 p-2': !published && strokeWidth === 'md',
        'border-info border-dotted p-2': !published,
        relative: showIcon,
      })}
    >
      {showIcon && <UnpublishedIcon absolute />}
      {children}
    </div>
  );
}

type UnpublishedIconProps = Omit<FontAwesomeIconProps, 'icon'> & {
  absolute?: boolean;
};

export function UnpublishedIcon({
  className,
  absolute,
  ...props
}: UnpublishedIconProps) {
  return (
    <FontAwesomeIcon
      icon={faEyeSlash}
      className={cn(
        'opacity-75 text-info text-3xl',
        { 'absolute right-2 top-2': absolute },
        className,
      )}
      {...props}
    />
  );
}
